//--> import city from "@/api/search";

import * as apiCommon from "../../api/common"

import * as apiStore from '../../api/store';
import * as apiRoom from '../../api/room';
/**
 * 搜索框的全局数据
 */
const search = {
  state: {
    /*所有城市*/
    allCity: [],
    /*字母排序的所有城市*/
    orderAllCity: [],
    /*城市*/
    cityName: '选择城市',
    /*城市编码*/
    cityCode: '',
    /*具体位置*/
    region: '',
    /*具体经纬度*/
    point: { "lng": "", "lat": "" },
    /*时间范围*/
    dateRange: '',
    // 民宿名称
    storeName: '',
  },

  mutations: {
    SET_ALLCITY: (state, allCity) => {
      state.allCity = allCity
    },
    SET_ORDERALLCITY: (state, orderAllCity) => {
      state.orderAllCity = orderAllCity
    },
    SET_CITYNAME: (state, cityName) => {
      state.cityName = cityName
    },
    SET_CITYCODE: (state, cityCode) => {
      state.cityCode = cityCode
    },
    SET_REGION: (state, region) => {
      state.region = region
    },
    SET_POINT: (state, point) => {
      state.point = point
    },
    SET_DATERANGE: (state, dateRange) => {
      state.dateRange = dateRange
    }
  },

  actions: {
    getAllCity({ commit }) {
      let that = this;
      return new Promise((resolve, reject) => {

          apiCommon.allCityOrderByPY("0").then((res) => {

          let cityList = res.result
          // console.log('cityList============',cityList)
            //获取所有民宿的城市，只显示有民宿的城市
            let data ={}
            apiRoom.getStoreListByRoom(data).then(sr=>{
              // console.log('sr==========',sr)
              let paramsStore ={
                pageNumber: 1,
                pageSize: 600,
                myLatitude: 0,
                myLongitude: 0,
                orderBy: '', // distance
                orderType: '', // asc/desc
                storeDisable: 'OPEN',
                // ids: ['00000000'],//默认一个不存在的ID传，防止这个查询条件为空
                ids: []
              };
              sr.data.forEach((item)=>{
                paramsStore.ids.push(item.storeId)
              })
              apiStore.getAllStoreWithHouseType(paramsStore).then(store=>{
                let cityListWithHouseType=[]
                store.result.forEach(s=>{
                  let str = s.storeAddressIdPath+'';
                  cityList.forEach(c=>{
                    if(str.includes(c.id)){
                      cityListWithHouseType.push(c);
                    }

                  })

                })

                const map = new Map()
                let data = cityListWithHouseType.filter((a)=> !map.has(a)&&map.set(a,1))



                //根据拼音首字母分组
                let list = []
                data.forEach((e, i, arr) => {
                  let py = e.py
                  if (list[py]) {
                    list[py].push(e)
                  }
                  else {
                    list[py] = [e]
                  }
                })
                //不按拼音排序直接显示的列表
                let allCities = []
                let c = {list:[]}
                data.forEach(e=>{
                  c.list.push(e)
                })
                allCities.push(c)
                //拼接按拼音排序的列表
                let pinyinList = Object.keys(list)
                let cities = []
                pinyinList.forEach(e=>{
                  let a ={pinyin:'',list:[]}
                  a.pinyin = e
                  a.list = list[e]
                  cities.push(a)
                })
                commit('SET_ALLCITY', allCities)
                commit('SET_ORDERALLCITY', cities)
                resolve(res)
              })
            })



        }).catch(error => {
          reject(error)
        })
      })
    },
    // getOrderAllCity({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     apiCommon.allCityOrderByPY("1").then((res) => {
    //       commit('SET_ORDERALLCITY', res.result)
    //       resolve(res)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    setSearchParam({ commit }, cityName, cityCode, region, point, dateRange) {
      commit('SET_CITYNAME', cityName)
      commit('SET_CITYCODE', cityCode)
      commit('SET_REGION', region)
      commit('SET_POINT', point)
      commit('SET_DATERANGE', dateRange)
    }

  }
}

export default search



// WEBPACK FOOTER //
// ./src/vuex/modules/search.js